import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ThemeProvider } from "../contexts/ThemeContext";
import { authAPI } from "../api";
import { Mail, Lock, User, Building, ArrowRight, ShieldCheck } from "lucide-react";

const SpaceJetNetworkClientSignup = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    company: "",
    type: "advertiser"
  });
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSubmitting(true);
    setError("");

    try {
      await authAPI.clientSignup(formData);
      navigate("/pending-approval?type=client");
    } catch (requestError) {
      setError(requestError.message || "Unable to submit signup request");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <ThemeProvider>
      <div className="min-h-screen bg-slate-900 spacejet-texture-dots flex items-center justify-center py-12 px-4">
        <div className="w-full max-w-2xl spacejet-glass rounded-2xl border border-slate-700/50 p-8">
          <p className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.14em] text-slate-300 mb-4">
            <ShieldCheck className="w-4 h-4" />
            Hidden Client Access Request
          </p>
          <h1 className="text-3xl font-bold text-slate-100 mb-2">Client Portal Signup</h1>
          <p className="text-slate-400 mb-8">Submit your request. Access remains pending until approved by admin.</p>

          <form onSubmit={handleSubmit} className="space-y-5">
            <label className="block">
              <span className="block text-sm text-slate-300 mb-2">Full Name</span>
              <div className="relative">
                <User className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
                <input name="name" value={formData.name} onChange={handleInputChange} required className="w-full pl-10 pr-4 py-3 bg-slate-800 border border-slate-600 rounded-lg text-slate-100" />
              </div>
            </label>

            <label className="block">
              <span className="block text-sm text-slate-300 mb-2">Email</span>
              <div className="relative">
                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
                <input type="email" name="email" value={formData.email} onChange={handleInputChange} required className="w-full pl-10 pr-4 py-3 bg-slate-800 border border-slate-600 rounded-lg text-slate-100" />
              </div>
            </label>

            <label className="block">
              <span className="block text-sm text-slate-300 mb-2">Password</span>
              <div className="relative">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
                <input type="password" minLength={6} name="password" value={formData.password} onChange={handleInputChange} required className="w-full pl-10 pr-4 py-3 bg-slate-800 border border-slate-600 rounded-lg text-slate-100" />
              </div>
            </label>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <label className="block">
                <span className="block text-sm text-slate-300 mb-2">Company</span>
                <div className="relative">
                  <Building className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
                  <input name="company" value={formData.company} onChange={handleInputChange} className="w-full pl-10 pr-4 py-3 bg-slate-800 border border-slate-600 rounded-lg text-slate-100" />
                </div>
              </label>

              <label className="block">
                <span className="block text-sm text-slate-300 mb-2">Account Type</span>
                <select name="type" value={formData.type} onChange={handleInputChange} className="w-full px-4 py-3 bg-slate-800 border border-slate-600 rounded-lg text-slate-100">
                  <option value="advertiser">Advertiser</option>
                  <option value="affiliate">Affiliate</option>
                </select>
              </label>
            </div>

            {error && <div className="rounded-lg px-4 py-3 text-sm spacejet-selected spacejet-accent-text">{error}</div>}

            <button type="submit" disabled={submitting} className="w-full px-8 py-4 disabled:opacity-60 text-slate-100 font-semibold rounded-lg flex items-center justify-center spacejet-btn-primary">
              {submitting ? "Submitting request..." : "Request Access"}
              <ArrowRight className="ml-2 w-5 h-5" />
            </button>
          </form>
        </div>
      </div>
    </ThemeProvider>
  );
};

export default SpaceJetNetworkClientSignup;
